import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { LineChartComponent } from './line-chart/line-chart.component';
import { LineChartRisksComponent } from './line-chart/line-chart-risks.component';

@NgModule({
  declarations: [
    PieChartComponent,
    BarChartComponent,
    LineChartComponent,
    LineChartRisksComponent
  ],
  exports: [
    PieChartComponent,
    BarChartComponent,
    LineChartComponent,
    LineChartRisksComponent
  ],
  imports: [CommonModule]
})
export class ChartsModule {}
